import React, { createContext, useContext } from 'react';
import { useAppStore } from './store';

export interface ProjectContext {
  currentProjectId: string | null;
  setCurrentProjectId: (projectId: string | null) => void;
}

const ProjectContext = createContext<ProjectContext | undefined>(undefined);

export function ProjectProvider({ children }: { children: React.ReactNode }) {
  const { selectedProject, setSelectedProject } = useAppStore();

  const setCurrentProjectId = (projectId: string | null) => {
    if (projectId && projectId !== selectedProject?.id) {
      // Create a minimal project object if we only have an ID
      setSelectedProject({
        id: projectId,
        name: 'Selected Project',
        hubId: '',
        status: 'active'
      });
    } else if (!projectId) {
      setSelectedProject(null);
    }
  };

  return (
    <ProjectContext.Provider value={{ 
      currentProjectId: selectedProject?.id || null, 
      setCurrentProjectId 
    }}>
      {children}
    </ProjectContext.Provider>
  );
}

export function useProject() {
  const context = useContext(ProjectContext);
  if (context === undefined) {
    throw new Error('useProject must be used within a ProjectProvider');
  }
  return context;
}